import type { TranslationTree } from '../../types';

export const admin: TranslationTree = {
  admin: {
    hero: {
      badge: 'Espace administrateur',
      title: 'Pilotez vos accès en toute simplicité',
      description:
        'Créez des comptes, attribuez des modules et synchronisez vos outils en quelques clics. Cet espace vous permet de garder la maîtrise de votre plateforme ToolLife.',
    },
    tabs: {
      users: 'Utilisateurs',
      tools: 'Outils',
    },
    sections: {
      userCreation: {
        title: 'Créer un nouveau compte utilisateur',
        description:
          "Renseignez les informations nécessaires et sélectionnez les modules auxquels l'utilisateur pourra accéder.",
      },
      toolCreation: {
        title: 'Enregistrer un nouvel outil',
        description:
          "Ajoutez un outil à la base de traçabilité pour le rendre disponible dans l'écosystème ToolLife.",
      },
    },
    registerForm: {
      fields: {
        firstName: {
          label: 'Prénom',
          placeholder: 'Ex. Jeanne',
        },
        lastName: {
          label: 'Nom',
          placeholder: 'Ex. Martin',
        },
        email: {
          label: 'Adresse e-mail',
          placeholder: 'prenom.nom@entreprise.ch',
        },
        company: {
          label: 'Entreprise',
          placeholder: "Nom de l'entreprise",
        },
        password: {
          label: 'Mot de passe',
          placeholder: '••••••••',
        },
        confirmPassword: {
          label: 'Confirmer le mot de passe',
          placeholder: '••••••••',
        },
      },
      role: {
        title: 'Rôle attribué',
        description: 'Activez cette option pour accorder les privilèges administrateur au compte.',
        adminLabel: 'Administrateur',
      },
      modules: {
        title: 'Modules accessibles',
        options: {
          traceability: {
            label: 'Traçabilité',
            description: 'Suivi temps réel des relevés de production.',
          },
          machineLearning: {
            label: 'Machine Learning',
            description: 'Accès aux modèles prédictifs pour anticiper les anomalies.',
          },
          analytics: {
            label: 'Analytics',
            description: 'Statistiques avancées et tableaux de bord dédiés.',
          },
        },
      },
      submit: 'Créer le compte',
      success: 'Utilisateur ajouté avec succès !',
      errors: {
        passwordMismatch: 'Les mots de passe ne correspondent pas',
        default: 'Une erreur est survenue',
      },
    },
    registerToolForm: {
      fields: {
        toolId: {
          label: 'Identifiant outil',
          placeholder: 'Ex. TL-4587',
        },
        reference: {
          label: 'Référence interne',
          placeholder: 'Référence fabricant',
        },
        company: {
          label: 'Entreprise associée',
          placeholder: "Nom de l'entreprise",
        },
      },
      info: 'Les outils enregistrés ici seront immédiatement disponibles pour la traçabilité et les analyses ToolLife.',
      submit: "Ajouter l'outil",
      success: 'Outil ajouté avec succès !',
      errors: {
        default: 'Une erreur est survenue',
      },
    },
    permissionError: {
      title: 'Page non disponible',
      backHome: "Retour à l'accueil",
    },
  },
};
